import { r as registerInstance, c as createEvent, h, g as getElement, H as Host } from './index-6e9159ae.js';
import { n as isAncestorOf, q as getFocusedElement } from './utils-71996adb.js';
import './_commonjsHelpers-5ec8f9b7.js';

const AtomicFocusDetector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.focusEnter = createEvent(this, "focusEnter", 7);
    this.focusExit = createEvent(this, "focusExit", 7);
    this.focusWasContained = this.containsFocus;
  }
  get containsFocus() {
    const focusedElement = getFocusedElement();
    return !!focusedElement && isAncestorOf(this.host, focusedElement);
  }
  onFocusIn() {
    this.onFocusChanged();
  }
  onFocusOut() {
    this.onFocusChanged();
  }
  onFocusChanged() {
    const containsFocus = this.containsFocus;
    if (containsFocus === this.focusWasContained) {
      return;
    }
    this.focusWasContained = containsFocus;
    containsFocus ? this.focusEnter.emit() : this.focusExit.emit();
  }
  render() {
    return h(Host, { style: { display: 'contents' } });
  }
  get host() { return getElement(this); }
};

export { AtomicFocusDetector as atomic_focus_detector };

//# sourceMappingURL=atomic-focus-detector.entry.js.map